





import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "FileImageView",
  components: { BaseIcon },
  props: {
    icon: { type: String, required: true },
    isPublic: { type: Boolean, default: false },
  },
});
